
import { NgModule } from '@angular/core';
import { LoginFlowService } from './flows/login-flow.service';
import { UserService } from './crud/user.service';
import { AppFirebaseModule } from './app-firebase.module';
import { SemtService } from './crud/semt.service';
import { BaseFirestoreService } from './crud/base-firestore.service';
import { BrandService } from './crud/brand.service';
import { CreateOrderFlowService } from './flows/create-order-flow.service';
import { MyCartFlowService } from './flows/my-cart-flow.service';
import { BrandOwnerService } from './crud/brand-owner.service';
import { OrderService } from './crud/order.service';
import { HttpClientModule } from '@angular/common/http';
import { AppOneSignalService } from './onesignal.service';

@NgModule({
  imports: [
    AppFirebaseModule,
    HttpClientModule
  ],
  exports: [
  ],
  providers: [
    LoginFlowService,
    BaseFirestoreService,
    UserService,
    SemtService,
    BrandService,
    CreateOrderFlowService,
    MyCartFlowService,
    BrandOwnerService,
    OrderService,
    AppOneSignalService
  ]
})
export class AppServiceModule { }
